import React from "react";
import FooterBottom from "./FooterBottom";
import FooterTop from "./FooterTop";

function Footer() {
  return (
    <>
      <FooterTop />
      <FooterBottom />
    </>
  );
}

export default Footer;
